import React from 'react';
import questions from '../data/questions';
import {
  TYPE_KAPHA,
  TYPE_PITTA,
  TYPE_VATA,
} from '../data/types';
import QuestionService from '../services/questionService';
import styles from '../styles/main.scss';
import { QuestionPage } from './question';
import { StartPage } from './start';
import { SummaryPage } from './summary';

const START_PAGE = 'start';
const QUESTION_PAGE = 'question';
const SUMMARY_PAGE = 'summary';

class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = { page: START_PAGE };

    this.questionService = new QuestionService(
      questions,
      [TYPE_KAPHA, TYPE_PITTA, TYPE_VATA],
    );

    this.appRef = React.createRef();
  }

  scrollToTop() {
    window.scrollTo(0, this.appRef.current.offsetTop);
  }

  renderStartPage() {
    return (
      <StartPage
        onContinueClick={() => {
          this.setState({ page: QUESTION_PAGE });
          this.scrollToTop();
        }}
        questionCount={this.questionService.getQuestionCount()}
      />
    );
  }

  renderQuestionPage() {
    return (
      <QuestionPage
        currentQuestion={this.questionService.getCurrentQuestion()}
        currentQuestionNumber={this.questionService.getCurrentQuestionNumber() + 1}
        hasPreviousQuestion={this.questionService.hasPreviousQuestion()}
        onReturnBack={() => {
          this.questionService.undoAnswer();
          this.scrollToTop();
          this.forceUpdate();
        }}
        onSaveAnswer={(answerIndex) => {
          if (!this.questionService.hasNextQuestion()) {
            this.setState({ page: SUMMARY_PAGE });
          }

          this.questionService.saveAnswer(answerIndex);
          this.scrollToTop();
          this.forceUpdate();
        }}
        questionCount={this.questionService.getQuestionCount()}
      />
    );
  }

  renderSummaryPage() {
    return (
      <SummaryPage
        answersStatistics={this.questionService.getAnswersStatistics()}
        onResetClick={() => {
          this.questionService = new QuestionService(
            questions,
            [TYPE_KAPHA, TYPE_PITTA, TYPE_VATA],
          );

          this.setState({ page: START_PAGE });
          this.scrollToTop();
        }}
        questionCount={this.questionService.getQuestionCount()}
      />
    );
  }

  render() {
    const { page } = this.state;
    let children = null;

    if (page === START_PAGE) {
      children = this.renderStartPage();
    } else if (page === QUESTION_PAGE) {
      children = this.renderQuestionPage();
    } else if (page === SUMMARY_PAGE) {
      children = this.renderSummaryPage();
    }

    return (
      <div
        className={styles.app}
        ref={this.appRef}
      >
        {children}
      </div>
    );
  }
}

export default App;
